import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { SiteNavigationLinkGroupsPropType } from '../../../../../../../../services/proptypes';
import { classNames } from '../../../../../../../../utils/classname';
import FadeReveal from '../../../../../../../animations/components/Reveal/variants/FadeReveal';
import Accordion from '../../../../../../../foundation/components/Accordion';
import { RefPropType } from '../../../../../../../foundation/types/component';
import { ITEM_NAVIGATION_MODE } from '../../PopupAccordionMenuLink.constants';
import { NavigationModePropType } from '../../PopupAccordionMenuLink.types';
import { MAX_LINKS_TO_SHOW } from '../AccordionLinks/AccordionLinks.constants';
import MasonryAccordionLinks from '../MasonryAccordionLinks';
import ParentAccordionLinks from '../ParentAccordionLinks';
import './PopupContent.less';
var defaultProps = {
  onMouseEnter: function onMouseEnter() {
    return null;
  },
  onMouseLeave: function onMouseLeave() {
    return null;
  },
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  initialActiveIndices: [],
  onLinkClick: function onLinkClick() {
    return null;
  },
  onClose: function onClose() {
    return null;
  },
  containerRef: null,
  navigationMode: ITEM_NAVIGATION_MODE
};
export default function PopupContent(_ref) {
  var links = _ref.links,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    maxLinksToShow = _ref.maxLinksToShow,
    initialActiveIndices = _ref.initialActiveIndices,
    onLinkClick = _ref.onLinkClick,
    onClose = _ref.onClose,
    containerRef = _ref.containerRef,
    navigationMode = _ref.navigationMode;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    activeNavigationGroup = _useState2[0],
    setActiveNavigationGroup = _useState2[1];
  var navigationGroupNames = Object.keys(links);
  var isSingleGroup = navigationGroupNames.length === 1;
  var finalClassName = classNames({
    'popup-content-container': true,
    'single-group': isSingleGroup,
    'multi-group': !isSingleGroup
  });
  function onAccordionClick(navigationGroupName) {
    setActiveNavigationGroup(function (prevActiveNavigationGroup) {
      return prevActiveNavigationGroup === navigationGroupName ? '' : navigationGroupName;
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: finalClassName,
    ref: containerRef
  }, isSingleGroup && /*#__PURE__*/React.createElement(MasonryAccordionLinks, {
    links: links[navigationGroupNames[0]],
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    maxLinksToShow: maxLinksToShow,
    initialActiveIndices: initialActiveIndices,
    onLinkClick: onLinkClick,
    navigationMode: navigationMode
  }), !isSingleGroup && /*#__PURE__*/React.createElement(FadeReveal, null, /*#__PURE__*/React.createElement(Accordion, {
    className: "parent-accordion-links"
  }, navigationGroupNames.map(function (navigationGroupName) {
    return /*#__PURE__*/React.createElement(ParentAccordionLinks, {
      key: navigationGroupName,
      navigationGroup: navigationGroupName,
      links: links[navigationGroupName],
      activeNavigationGroup: activeNavigationGroup,
      onAccordionClick: onAccordionClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      maxLinksToShow: maxLinksToShow,
      initialActiveIndices: initialActiveIndices,
      onLinkClick: onLinkClick,
      onClose: onClose,
      navigationMode: navigationMode
    });
  }))));
}
PopupContent.defaultProps = defaultProps;